export default __webpack_public_path__ + "static/media/i014vp.8c4d7cf9.webp";